module.exports = __webpack_public_path__ + "static/media/w_w_hb_25.8151bc09.png";